import { render, staticRenderFns } from "./LinkCompanion.vue?vue&type=template&id=48c15662&scoped=true&"
import script from "./LinkCompanion.vue?vue&type=script&lang=js&"
export * from "./LinkCompanion.vue?vue&type=script&lang=js&"
import style0 from "./LinkCompanion.vue?vue&type=style&index=0&id=48c15662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c15662",
  null
  
)

export default component.exports